import { ActionType } from '../../classes/action-type';
import { ICalendarStateAction } from '../interfaces/calendar-state.action';
import { ICalendarSettings, defaultCalendarSettings, CalendarDeviceMode, CalendarViewMode } from '../interfaces/calendar-settings';

/**
 * Simple reducer to update the calendar settings.
 * 
 * NOT CURRENTLY IN USE
 */
export default function calendarSettingsReducer(state: ICalendarSettings = defaultCalendarSettings, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value } as ICalendarSettings;
        }
        case ActionType.SetToDesktop: {
            return { ...state, calendarDeviceMode: CalendarDeviceMode.DESKTOP } as ICalendarSettings;
        }
        case ActionType.SetToMobile: {
            return { ...state, calendarDeviceMode: CalendarDeviceMode.MOBILE, calendarViewMode: CalendarViewMode.LIST } as ICalendarSettings;
        }
        case ActionType.SetToGrid: {
            return { ...state, calendarViewMode: CalendarViewMode.GRID } as ICalendarSettings;
        }
        case ActionType.SetToList: {
            return { ...state, calendarViewMode: CalendarViewMode.LIST } as ICalendarSettings;
        }
        default:
            return state;
    }
}
